
import store from '@/store';
import { computed, defineComponent, PropType } from '@vue/composition-api';

export default defineComponent({
  props: {
    title: {
      type: String,
      required: true,
    },
    type: {
      type: String as PropType<'node' | 'edge'>,
      required: true,
    },
    showTitle: {
      type: Boolean,
      default: true,
    },
  },

  setup(props) {
    const edgeVariables = computed(() => store.state.edgeVariables);
    const nestedVariables = computed(() => store.state.nestedVariables);

    function elementDrop(event: DragEvent) {
      if (event.dataTransfer === null) {
        return;
      }

      const droppedVarName = event.dataTransfer.getData('attr_id').substring(5);

      if (props.type === 'node' && props.title === 'bars') {
        const updatedNestedVars = {
          bar: [...nestedVariables.value.bar, droppedVarName],
          glyph: nestedVariables.value.glyph,
        };
        store.commit.setNestedVariables(updatedNestedVars);
      } else if (props.type === 'node' && props.title === 'glyphs') {
        const updatedNestedVars = {
          bar: nestedVariables.value.bar,
          glyph: [...nestedVariables.value.glyph, droppedVarName],
        };
        store.commit.setNestedVariables(updatedNestedVars);
      } else if (props.type === 'node' && props.title === 'size') {
        store.commit.setNodeSizeVariable(droppedVarName);
      } else if (props.type === 'node' && props.title === 'color') {
        store.commit.setNodeColorVariable(droppedVarName);
      } else if (props.type === 'edge' && props.title === 'width') {
        const updatedEdgeVars = {
          width: droppedVarName,
          color: edgeVariables.value.color,
          time: edgeVariables.value.time,
        };
        store.commit.setEdgeVariables(updatedEdgeVars);
      } else if (props.type === 'edge' && props.title === 'color') {
        const updatedEdgeVars = {
          width: edgeVariables.value.width,
          color: droppedVarName,
          time: edgeVariables.value.time,
        };
        store.commit.setEdgeVariables(updatedEdgeVars);
      } else if (props.type === 'edge' && props.title === 'time') {
        // TODO: https://github.com/multinet-app/multidynamic/issues/6
        // Make more elegant edge filter
        const updatedEdgeVars = {
          width: droppedVarName,
          color: edgeVariables.value.color,
          time: droppedVarName,

        };
        store.commit.setEdgeVariables(updatedEdgeVars);
      }
    }

    return {
      elementDrop,
    };
  },
});
